export default "__VITE_ASSET__DC7F59ju__"